import { convertDate } from '../../helpers/dateFormat';
// import styles from '../../../styles/page.scss'
import { ProductionStatus } from '../production-steps'


export const ProductionColumn = [
    {
        title: 'Project Id',
        dataIndex: 'global_project_id',
    },
    {
        title: 'Received Date',
        dataIndex: 'createdAt',
        render: (createdAt) => {
            return convertDate(String(createdAt))
        }
    },
    {
        title: 'Deadline Delivery Date',
        dataIndex: 'client_expected_delivery_date',
        render: (client_expected_delivery_date) => {
            return client_expected_delivery_date 
                ? convertDate(String(client_expected_delivery_date)) 
                : 'N/A';
        }
    },
    {
        title: 'Status',
        dataIndex: 'vendor_status',
        render: status => ProductionStatus[status],

    }

]

export const ProductionKanabanColumn = [
    {
        key: 1,
        title: 'New Order'
    },
    {
        key: 2,
        title: 'Template Requested'
    },
    {
        key: 3,
        title: 'Template Sent'
    },
    {
        key: 4,
        title: 'ArtWork Received'
    },
    {
        key: 5,
        title: 'Final Proof Sent'
    },
    {
        key: 6,
        title: 'Approved by Leoprinting'
    },
    {
        key: 7,
        title: 'On Hold'
    },
    {
        key: 8,
        supplierStatus: 2,
        title: 'In Production'
    },
    {
        key: 9,
        supplierStatus: 3,
        title: 'Expected Dispatch date'
    },
    {
        key: 10,
        supplierStatus: 4,
        title: 'In Transit'
    },
    {
        key: 11,
        supplierStatus: 5,
        title: 'Delivered'
    },

]